import { AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { environment } from '@env/environment';
import Cookies from 'js-cookie';
import { LocalStorage } from 'thkee-common';
const DEFAULT_LANGUAGE = 'ar-SA';

@Component({
  selector: 'app-turnstile',
  standalone: true,
  imports: [],
  templateUrl: './turnstile.component.html',
  styleUrl: './turnstile.component.scss',
})
export class TurnstileComponent implements AfterViewInit, OnDestroy, AfterViewChecked {
  @Input() siteKey: string = environment.siteKey; // Pass your Turnstile Site Key
  @Output() tokenReceived = new EventEmitter<string>();
  @Output() tokenExpired = new EventEmitter<void>();
  @Input() isTurnstileInPopup: boolean = false;

  private widgetId: string | null = null;

  constructor() {
    // Define Turnstile's global callbacks
    window.onTurnstileCallback = (token: string) => this.handleCallback(token);
    window.onTurnstileExpiredCallback = () => this.handleExpired();
  }

  ngAfterViewInit(): void {
    this.loadTurnstile();
  }

  ngAfterViewChecked(): void {
    if (!this.widgetId && this.isTurnstileInPopup) {
      this.loadTurnstile();
    }
  }

  private loadTurnstile() {
    if (window.turnstile) {
      const widgetContainer = document.getElementById('turnstile-widget');
      if (widgetContainer) {
        this.widgetId = window.turnstile.render(widgetContainer, {
          sitekey: this.siteKey,
          callback: (token: string) => this.tokenReceived.emit(token),
          'expired-callback': () => this.tokenExpired.emit(),
          language: LocalStorage.getText('lang') || Cookies.get('lang') || DEFAULT_LANGUAGE, // Pass the dynamic language here
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }

    // Clean up global callbacks
    delete (window as any).onTurnstileCallback;
    delete (window as any).onTurnstileExpiredCallback;
  }

  private handleCallback(token: string): void {
    this.tokenReceived.emit(token);
  }

  private handleExpired(): void {
    this.tokenExpired.emit();
  }
}
